<script setup lang="ts">
import SVGWrapper from "./utils/SVGWrapper.vue";

import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
}

withDefaults(defineProps<IconProps>(), { size: "md" });
</script>

<template>
  <SVGWrapper :size="size" viewBox="0 0 24 24">
    <mask
      id="mask0_17114_57699"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="21"
      height="21"
    >
      <circle cx="12.1348" cy="12.043" r="10" transform="rotate(-90 12.1348 12.043)" fill="white" />
    </mask>
    <g mask="url(#mask0_17114_57699)">
      <rect
        x="0.628906"
        y="17.002"
        width="10.1826"
        height="21.8535"
        transform="rotate(-90 0.628906 17.002)"
        fill="#FFE70D"
      />
      <rect
        x="0.28125"
        y="8.01172"
        width="7.15234"
        height="21.8535"
        transform="rotate(-90 0.28125 8.01172)"
        fill="#DF3636"
      />
      <rect
        x="0.28125"
        y="23.2598"
        width="7.15234"
        height="21.8535"
        transform="rotate(-90 0.28125 23.2598)"
        fill="#DF3636"
      />
    </g>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
